
export default {
  name: "ArticleTableContentsBlock",

  data: function () {
    return {
      structure: [],
      countRepeat: 0
    }
  },

  mounted: function () {
    this.initStructure();
  },

  methods: {
    initStructure: function () {
      const parent = document.getElementById('ArticleTableContentsBlock').closest('.article-page__cms-content') || this.$parent?.$el || "";
      const selectors = parent.querySelectorAll("h2,h3");
      if (selectors.length <= 0 && this.countRepeat <= 5) {
        this.countRepeat = this.countRepeat + 1;
        setTimeout(() => {
          this.initStructure();
        }, 1000);
        return
      }
      let structure = [];
      selectors.forEach((element) => {
        const innerText = element?.innerText || "";
        if (!innerText) {
          return
        }
        let level = 1;
        if (element?.nodeName === 'H3') {
          level = 2;
        }
        structure.push({
          level: level,
          title: innerText,
          element: element
        })
      });
      this.structure = structure;
    },

    scrollToElement: function (item) {
      const scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
      const elementTop = item.element.getBoundingClientRect().top;
      const headerHeight = document.getElementsByClassName('header')?.[0].getBoundingClientRect().height;
      window.scrollTo({
        top: elementTop + scrollTop - headerHeight - 20,
        behavior: "smooth"
      });
    }
  }
}
